import React from 'react';
import styles from './LandSummaryRow.module.css';

/*
    LAND SUMMARY ROW (dumb molecule)
        Single read-only fact: label, then a value chip or plain text starting
        right after it. An optional sourceLink follows in the same column (e.g.
        the Welsh Government agricultural-pollution rules for a Welsh zone).

        Label column plus content column, matching GradedLayerRow, because
        `space-between` left a wide empty channel down the middle of the card
        (BBB-454, second pass 20/08).
        props:
            title: str
            value: str
            variant: 'none' | 'in' | 'plain' (default 'plain')
            sourceLink: { label: str, url: str } | undefined
*/

const LandSummaryRow = (props) => {
  const variant = props.variant || 'plain';
  const { sourceLink } = props;

  const valueEl =
    variant === 'plain' ? (
      <span className={styles.value}>{props.value}</span>
    ) : (
      <span className={`${styles.chip} ${variant === 'none' ? styles.chipNone : styles.chipIn}`}>
        {props.value}
      </span>
    );

  return (
    <div className={styles.card}>
      <span className={styles.label}>{props.title}</span>
      <div className={styles.content}>
        {valueEl}
        {sourceLink ? (
          <a
            className={styles.sourceLink}
            href={sourceLink.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {sourceLink.label}
          </a>
        ) : null}
      </div>
    </div>
  );
};

export default React.memo(LandSummaryRow);
